module.exports = __webpack_public_path__ + "img/profileW.4671811a.svg";